import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import WhiteConfirmation from './WhiteConfirmation';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  setAppFlow,
  apptNotModified
} from 'store/reducers/userInteractions/actions';
import { getTransportationOptions } from 'store/reducers/apptOptions/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { updatePackageInfo } from 'store/reducers/packages/actions';
import {
  getOptOutCustomerForSMSMarketing,
  getOptInUrl,
  changeOptStatus
} from 'store/reducers/marketing/actions';

// Selectors

import {
  dealerSettingsSelector,
  getDealerName,
  getDealerContact,
  getSymptomSurveyEnabled,
  getMarketingSMSConfiguration,
  getFlexPayConfiguration,
  getFlexPayProviders,
  getExternalValetProvider
} from 'store/reducers/dealerSettings/selectors';

import {
  getAppointment,
  getConfirmationKey,
  getTransportationOption
} from 'store/reducers/appointment/selectors';
import { getDeferredServicesIds } from 'store/reducers/deferred/selectors';
import { getAppFlow } from 'store/reducers/userInteractions/selectors';
import { getDealerServerUrl } from 'store/reducers/dealerData/selectors';
import { dealerLogoURL } from 'store/reducers/localizationString/selectors';
import { getWebkey } from 'store/reducers/queryParams/selectors';
import {
  getOptStatus,
  getOptInUrlSelector
} from 'store/reducers/marketing/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => {
  return {
    dealerSettings: dealerSettingsSelector(state),
    appFlow: getAppFlow(state),
    appointmentData: getAppointment(state),
    deferredServicesIds: getDeferredServicesIds(state),
    dealerName: getDealerName(state),
    dealerContact: getDealerContact(state),
    dealerServerUrl: getDealerServerUrl(state),
    dealerLogoURL: dealerLogoURL(state),
    webKey: getWebkey(state),
    confirmationKey: getConfirmationKey(state),
    symptomSurveyEnabled: getSymptomSurveyEnabled(state),
    marketingSMSConfiguration: getMarketingSMSConfiguration(state),
    optStatus: getOptStatus(state),
    optInUrl: getOptInUrlSelector(state),
    localeCode: getLocaleCode(state),
    flexPayConfiguration: getFlexPayConfiguration(state),
    flexPayProviders: getFlexPayProviders(state),
    externalValet: getExternalValetProvider(state),
    transportationOption: getTransportationOption(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      goTo,
      setAppFlow,
      apptNotModified,
      getTransportationOptions,
      gtmUserEvent,
      updatePackageInfo,
      getOptOutCustomerForSMSMarketing,
      getOptInUrl,
      changeOptStatus
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WhiteConfirmation);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/WhiteConfirmation/WhiteConfirmationContainer.js